import { publicApi } from './api'

export async function getEventoPublico(slug) {
  const { data } = await publicApi.get(`/pub/eventos/${slug}`)
  return data.evento
}

export async function criarInscricao(payload) {
  const { data } = await publicApi.post('/pub/inscricoes', payload)
  return data
}

export async function getCheckout(inscricaoId) {
  const { data } = await publicApi.get(`/pub/checkout/${inscricaoId}`)
  return data
}

export async function getCheckoutStatus(inscricaoId) {
  const { data } = await publicApi.get(`/pub/checkout/${inscricaoId}/status`)
  return data
}

export async function getSucesso(inscricaoId) {
  const { data } = await publicApi.get(`/pub/sucesso/${inscricaoId}`)
  return data.inscricao
}

export async function validarCupom(payload) {
  const { data } = await publicApi.post('/pub/cupons/validar', payload)
  return data
}

/**
 * Reenvio pedido pelo proprio inscrito.
 *
 * A resposta traz o e-mail mascarado (`ju***@gmail.com`): o servidor nao devolve
 * o endereco inteiro porque o unico segredo dessa rota e o id da inscricao, que
 * circula em link e e-mail.
 */
export async function reenviarConfirmacaoPublica(inscricaoId) {
  const { data } = await publicApi.post(`/pub/inscricao/${inscricaoId}/reenviar-confirmacao`)
  return data
}
